/* src/app/internal-admin/internal-admin-presenter/internal-admin-presenter.component.scss */
body#themeTag :host ::ng-deep .p-message-icon {
  width: auto !important;
}
body#themeTag :host ::ng-deep .p-message-summary {
  width: auto !important;
}
body#themeTag :host ::ng-deep .p-message .p-message-wrapper {
  padding: 0.2rem !important;
}
body#themeTag :host ::ng-deep div span {
  width: 100%;
}
body#themeTag :host ::ng-deep .p-button span,
body#themeTag :host ::ng-deep .p-button .p-button-icon,
body#themeTag :host ::ng-deep .p-button .p-button-label {
  width: auto !important;
}
body#themeTag :host ::ng-deep .p-inputtext.p-component.p-element {
  min-width: 100% !important;
  max-width: 100% !important;
  font-size: 0.85rem;
}
body#themeTag :host ::ng-deep .p-dropdown.p-component {
  width: 100% !important;
  text-align: start;
}
body#themeTag :host ::ng-deep .p-dropdown-trigger {
  text-align: center;
}
body#themeTag :host ::ng-deep .p-inline-message.p-component.p-inline-message-info {
  width: 99%;
  text-align: center;
}
body#themeTag :host ::ng-deep .p-inline-message-icon {
  width: 2em;
  text-align: center;
}
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-top: 0.5rem;
}
body#themeTag :host ::ng-deep .p-datatable-wrapper {
  border-radius: 4px;
}
.ef-customer-ddl {
  width: fit-content !important;
}
.glass {
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
}
/*# sourceMappingURL=internal-admin-presenter.component.css.map */
